/* kn-promise-day — corrigeert de bezorgdag in de leverbelofte op de HELE winkel.
 *
 * Waarom dit bestaat. De belofte staat op tientallen plekken als vaste tekst:
 * in de balk bovenaan (uit een metaobject), in de koopblok-regel op elke
 * productpagina, in de keuzehulp en in de lp-secties van de oude landers. Al die
 * plekken zeggen "morgen in huis". Op zaterdag, zondag en de zeven feestdagen
 * klopt dat niet: er wordt dan niet verzonden, dus het pakket komt op dinsdag.
 * Dat zijn ruim honderd dagen per jaar, op de pagina's met het meeste verkeer.
 *
 * De lx-landers hadden dit al opgelost, maar die hebben hun eigen engine
 * (assets/kn-lx.js) en die laadt alleen daar. Dit script doet hetzelfde voor de
 * rest van de winkel, en laat `[data-lx-promise]` met rust zodat de twee elkaar
 * niet in de weg zitten.
 *
 * Wat het NIET doet: op een gewone werkdag voor de cutoff verandert er niets.
 * Dan klopt "morgen in huis" gewoon en raakt het script geen enkele tekstnode
 * aan. Het grijpt alleen in op de dagen waarop de zin onwaar zou zijn.
 *
 * De rekenregels staan bewust gelijk aan promiseCalc in tools/lx/kn-lx.js:
 * verzenden op ma-vr buiten de feestdagen, bezorgen op ma-vr plus zaterdag als
 * die aan staat, alles in Europe/Amsterdam. Wijzig je er een, wijzig dan beide.
 */
(function (w, d) {
  'use strict';

  var cfgEl = d.querySelector('[data-kn-promise-cfg]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
  if (cfg.mode && cfg.mode !== 'next_day') return;   /* winkel belooft geen volgende dag */

  function calc(now) {
    var TZ = 'Europe/Amsterdam', o = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
        .formatToParts(now).forEach(function (x) { o[x.type] = x.value; });
    } catch (e) {
      o = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate(), hour: now.getHours(), minute: now.getMinutes() };
    }
    var y = +o.year, mo = +o.month, dd = +o.day;
    var mins = (+o.hour % 24) * 60 + (+o.minute);
    var cp = String(cfg.cutoff || '23:30').split(':');
    var cutoff = (parseInt(cp[0], 10) || 23) * 60 + (parseInt(cp[1], 10) || 0);
    var hol = String(cfg.holidays || '').split(/[\s,;]+/).filter(Boolean);
    var sat = cfg.saturday !== false;
    var today = Date.UTC(y, mo - 1, dd);
    function iso(t) { return new Date(t).toISOString().slice(0, 10); }
    function wd(t) { return new Date(t).getUTCDay(); }
    function isHol(t) { return hol.indexOf(iso(t)) > -1; }
    function add(t, n) { return t + n * 864e5; }
    function shipDay(t) { var k = wd(t); return k >= 1 && k <= 5 && !isHol(t); }
    function delDay(t) { var k = wd(t); return ((k >= 1 && k <= 5) || (sat && k === 6)) && !isHol(t); }
    var ship = (shipDay(today) && mins < cutoff) ? today : null, i = 1;
    while (ship === null && i < 40) { var c = add(today, i); if (shipDay(c)) ship = c; i++; }
    if (ship === null) ship = add(today, 1);
    var del = add(ship, 1), j = 0;
    while (!delDay(del) && j < 40) { del = add(del, 1); j++; }
    return { shipToday: ship === today, offset: Math.round((del - today) / 864e5), delWeekday: wd(del) };
  }

  var r = calc(new Date());
  w.KNPromise = { calc: function () { return calc(new Date()); } };

  /* Klopt de tekst al? Dan niets aanraken. Dat is het normale geval op werkdagen. */
  if (r.shipToday && r.offset === 1) return;

  var days = String(cfg.weekdays || 'zondag,maandag,dinsdag,woensdag,donderdag,vrijdag,zaterdag').split(',');
  var day = (days[r.delWeekday] || '').trim();
  if (!day) return;
  var todayPrefix = String(cfg.today_prefix || 'Vandaag besteld,');

  /* De cutoff-clausule kent vijf schrijfwijzen in de winkel: "Voor 23:30 besteld,",
     "Voor 23:30 =", "Voor 23:30 besteld op werkdagen,", "... op werkdagen =" en
     "... op een werkdag:". Eén patroon vangt ze alle vijf. Hij staat soms in
     dezelfde tekstnode als de dag en soms in de node ervoor; allebei afgevangen. */
  var CLAUSE = '([Vv]oor\\s+\\d{1,2}:\\d{2}(?:\\s+besteld)?(?:\\s+op\\s+(?:werkdagen|een\\s+werkdag))?\\s*[,:=]\\s*)';
  var SAME = new RegExp(CLAUSE + '?\\b([Mm])orgen\\b(\\s+(?:in\\s+huis|bezorgd))', 'g');
  var TRAIL = new RegExp(CLAUSE + '$');

  function prefixFor(match) {
    /* begon de zin met een kleine letter, dan blijft dat zo */
    return /^voor/.test(match) ? todayPrefix.charAt(0).toLowerCase() + todayPrefix.slice(1) + ' ' : todayPrefix + ' ';
  }

  function run() {
    var walker = d.createTreeWalker(d.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var t = p.nodeName;
        if (t === 'SCRIPT' || t === 'STYLE' || t === 'NOSCRIPT' || t === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        if (p.closest('[data-lx-promise]')) return NodeFilter.FILTER_REJECT;  /* kn-lx.js doet die al */
        return /morgen/i.test(n.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var hits = [], n;
    while ((n = walker.nextNode())) hits.push(n);

    hits.forEach(function (node) {
      var before = node.nodeValue;
      var after = before.replace(SAME, function (_, clause, m, tail) {
        var dagwoord = m === 'M' ? day.charAt(0).toUpperCase() + day.slice(1) : day;
        return (clause ? prefixFor(clause) : '') + dagwoord + tail;
      });
      if (after === before) return;
      node.nodeValue = after;

      /* Stond de clausule in de vorige tekstnode ("Voor 23:30 besteld, " gevolgd
         door <b>morgen in huis</b>)? Dan die daar weghalen, anders blijft er een
         cutoff staan die vandaag niets meer betekent. */
      if (!TRAIL.test(before)) {
        var host = node.parentElement && node.parentElement.closest('p,li,span,div,td,h1,h2,h3,h4');
        if (!host) return;
        var w2 = d.createTreeWalker(host, NodeFilter.SHOW_TEXT), prev = null, cur;
        while ((cur = w2.nextNode())) {
          if (cur === node) break;
          prev = cur;
        }
        if (prev && TRAIL.test(prev.nodeValue)) {
          prev.nodeValue = prev.nodeValue.replace(TRAIL, function (_, clause) { return prefixFor(clause); });
        }
      }
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run);
  else run();
  /* De balk bovenaan wordt door een swiper gekloond en de winkelwagenlade wordt
     opnieuw opgebouwd. Eén herhaling na het laden vangt dat af, zonder een
     permanente observer op het hele document. */
  w.addEventListener('load', function () { setTimeout(run, 400); });
})(window, document);
